// Execute a list of asynchronous functions in a flow, i.e. one after another (and NOT in parallel)
async function asyncFlowExecutor(listOfAsyncFunctions, assembledData = []) {
    if (listOfAsyncFunctions.length === 0) {
        return assembledData;
    }

    const func = listOfAsyncFunctions.shift();
    assembledData.push(await func());
    return await asyncFlowExecutor(listOfAsyncFunctions, assembledData);
}

export default {
    asyncFlowExecutor,

    // Returns a function, that, as long as it continues to be invoked, will not be triggered.
    // The function will be called after it stops being called for "wait" milliseconds.
    // If "immediate" is passed, trigger the function on the leading edge, instead of the trailing.
    debounce(func, wait, immediate) {
        let timeout;

        /* eslint-disable consistent-this */
        return function(...args) {
            const context = this;
            const callNow = immediate && !timeout;

            clearTimeout(timeout);
            timeout = setTimeout(() => {
                timeout = null;
                if (!immediate) {
                    func.apply(context, args);
                }
            }, wait);

            if (callNow) {
                func.apply(context, args);
            }
        };
    },

    // Converts a callback-based function into an async Promise-based function.
    // This only works if the following conditions are met: (1) the callback is the last parameter the function accepts, and (2) the callback gets only one argument
    promisify(func) {
        return async function(...args) {
            return new Promise(resolve => func(...args, resolve));
        };
    },

    // Build a web worker from an anonymous function body
    worker(workerFunction) {
        const funcBlob = new Blob(['(', workerFunction.toString(), ')()'], { type: 'application/javascript' });
        const blobURL = URL.createObjectURL(funcBlob);
        return new Worker(blobURL);
    }
};
